import React from 'react'
import { Category, PlanFragment, StripeSubscription } from 'src/graphql'
import { PlanTileGroup, RoundedFooter } from 'src/marketing/plans/components'
import FeatureCell from './FeatureCell'

export const discountDisclaimer: string[] = [
  '* Discounts apply to most gifts. Excludes: books, apparel, and Business Building Tools.',
  '** A Heartfelt Prompting Card has an immediate send date with only one recipient attached.',
  '*** An Automated Send card has a future send date or more than one recipient.',
]

type PricingTableProps = {
  plans: PlanFragment[]
  categories: Category[]
  selectedColumn?: number
  onSelect: (plan: string, isKeepButton?: boolean) => void
  stripeSubscription?: Partial<StripeSubscription>
  getPlan: (planId: string) => PlanFragment | undefined
}

const PricingTable: React.FC<PricingTableProps> = props => {
  const isTableVisible = false

  const { plans, categories, onSelect, stripeSubscription, getPlan } = props

  return (
    <>
      <PlanTileGroup
        plans={plans}
        onSelect={onSelect}
        shouldAddSpacer={isTableVisible}
        stripeSubscription={stripeSubscription}
        getPlan={getPlan}
      />
      <RoundedFooter
        isOpen={isTableVisible}
        messages={discountDisclaimer}
        actionTitle={isTableVisible ? 'Hide Comparison' : 'View Comparison'}
        onClick={() => {}}
        isChartAvailable={false}
      />
      <FeatureCell categories={categories} isOpen={isTableVisible} />
    </>
  )
}

export default PricingTable
